{
 "hash": "13f4d8dccbdf8afd",
 "version": "0.5.0",
 "locations": [
  {
   "id": "conjuration",
   "name": "Dept. of Conjuration",
   "keyword": "department",
   "gives": [
    "red"
   ],
   "text": "Gain {R}.",
   "effect": [
    {
     "op": "gain",
     "red": 1
    }
   ],
   "kind": "location"
  },
  {
   "id": "transmutation",
   "name": "Dept. of Transmutation",
   "keyword": "department",
   "gives": [
    "yellow"
   ],
   "text": "Gain {Y}.",
   "effect": [
    {
     "op": "gain",
     "yellow": 1
    }
   ],
   "kind": "location"
  },
  {
   "id": "evocation",
   "name": "Dept. of Evocation",
   "keyword": "department",
   "gives": [
    "blue"
   ],
   "text": "Gain {B}{B}.",
   "effect": [
    {
     "op": "gain",
     "blue": 2
    }
   ],
   "kind": "location"
  },
  {
   "id": "divination",
   "name": "Dept. of Divination",
   "keyword": "department",
   "gives": [
    "green"
   ],
   "text": "Gain {G}{G}.",
   "effect": [
    {
     "op": "gain",
     "green": 2
    }
   ],
   "kind": "location"
  },
  {
   "id": "enchantment",
   "name": "Dept. of Enchantment",
   "keyword": "department",
   "gives": [
    "blue",
    "green"
   ],
   "text": "Gain {B}{G}.",
   "effect": [
    {
     "op": "gain",
     "blue": 1,
     "green": 1
    }
   ],
   "kind": "location"
  },
  {
   "id": "procuration",
   "name": "Dept. of Procuration",
   "keyword": "department",
   "gives": "any",
   "text": "Gain 1 permit of your choice.",
   "effect": [
    {
     "op": "choosePermits",
     "count": 1
    }
   ],
   "kind": "location"
  },
  {
   "id": "mana-conduit",
   "name": "The Mana Conduit",
   "keyword": "utility",
   "text": "Gain 3 {MANA}.",
   "effect": [
    {
     "op": "gain",
     "mana": 3
    }
   ],
   "kind": "location"
  },
  {
   "id": "arcanium",
   "name": "The Arcanium",
   "keyword": "market",
   "text": "You may pay 1 {MANA} to refresh the display. Then you may buy 1 spell from it.",
   "effect": [
    {
     "op": "buySpell"
    }
   ],
   "kind": "location"
  },
  {
   "id": "archive",
   "name": "The Archive",
   "keyword": "records",
   "text": "Draw 2 Action cards.",
   "effect": [
    {
     "op": "draw",
     "n": "archive"
    }
   ],
   "kind": "location"
  },
  {
   "id": "planning-office",
   "name": "The Planning Office",
   "keyword": "records",
   "text": "Play up to 2 Action cards.",
   "effect": [
    {
     "op": "playActions",
     "max": "planning"
    }
   ],
   "kind": "location"
  },
  {
   "id": "grand-auditor",
   "name": "The Grand Auditor's Office",
   "keyword": "objective",
   "text": "Claim 1 City Problem whose requirement you meet.",
   "effect": [
    {
     "op": "claimProblem"
    }
   ],
   "kind": "location"
  },
  {
   "id": "precedence",
   "name": "The Office of Precedence",
   "keyword": "utility",
   "capacity": 1,
   "text": "Take the Stamp of Precedence (you go first from next round). Draw 1 Action card.",
   "effect": [
    {
     "op": "takeStamp"
    },
    {
     "op": "draw",
     "n": 1
    }
   ],
   "kind": "location"
  },
  {
   "id": "exchange-bureau",
   "name": "The Exchange Bureau",
   "keyword": "annex",
   "annex": true,
   "text": "Swap up to 2 permits for permits of your choice.",
   "effect": [
    {
     "op": "returnPermits",
     "max": 2
    }
   ],
   "kind": "location"
  },
  {
   "id": "lost-property",
   "name": "Lost Property",
   "keyword": "annex",
   "annex": true,
   "text": "Take 1 spell from the spell discard.",
   "effect": [
    {
     "op": "recoverSpell"
    }
   ],
   "kind": "location"
  },
  {
   "id": "shredding-room",
   "name": "The Shredding Room",
   "keyword": "annex",
   "annex": true,
   "text": "Discard up to 2 cards. Gain 1 permit of your choice for each.",
   "effect": [
    {
     "op": "shred",
     "max": 2
    }
   ],
   "kind": "location"
  },
  {
   "id": "stamp-pound",
   "name": "The Stamp Pound",
   "keyword": "annex",
   "annex": true,
   "text": "Your next spell this round costs 2 fewer permits.",
   "effect": [
    {
     "op": "modifier",
     "kind": "nextSpellPermits",
     "amount": 2
    }
   ],
   "kind": "location"
  },
  {
   "id": "complaints-desk",
   "name": "The Complaints Desk",
   "keyword": "annex",
   "annex": true,
   "text": "Take 1 {MANA} from each rival with more {VP}.",
   "effect": [
    {
     "op": "levy",
     "mana": 1,
     "from": "leaders"
    }
   ],
   "kind": "location"
  },
  {
   "id": "mailroom",
   "name": "The Mailroom",
   "keyword": "annex",
   "annex": true,
   "text": "Draw 1 Action card. Then play 1 Action card.",
   "effect": [
    {
     "op": "draw",
     "n": 1
    },
    {
     "op": "playActions",
     "max": 1
    }
   ],
   "kind": "location"
  }
 ],
 "spells": [
  {
   "id": "spell.efficient_inkflow_charm",
   "name": "Efficient Inkflow Charm",
   "school": "evocation",
   "formNo": "E-01",
   "price": 2,
   "cost": {
    "red": 1,
    "blue": 1
   },
   "vp": 1,
   "text": "At the start of each round, gain 1 {MANA}.",
   "flavor": "Ensures your quill is always 110% full. Approved by the Under-Scribe's Guild.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "roundStart"
     },
     "effect": [
      {
       "op": "gain",
       "mana": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.channelers_sanction",
   "name": "Channeler's Sanction",
   "school": "evocation",
   "formNo": "E-02",
   "price": 5,
   "cost": {
    "red": 1,
    "blue": 3
   },
   "vp": 3,
   "v1": {
    "vp": 4
   },
   "text": "Your Evocation spells cost 1 fewer {B} to cast (minimum 1 {B}).",
   "flavor": "Official permission to be loud, flashy, and utterly unsubtle with your magic.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "spellCost",
      "school": "evocation",
      "color": "blue",
      "delta": -1,
      "min": 1
     }
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.power_surge_regulation",
   "name": "Power Surge Regulation",
   "school": "evocation",
   "formNo": "E-03",
   "price": 7,
   "cost": {
    "yellow": 2,
    "blue": 4
   },
   "vp": 4,
   "v1": {
    "vp": 6
   },
   "text": "(End Game) Score 2 {VP} for each Evocation spell you have cast, including this one.",
   "flavor": "Prevents arcane brownouts. You get a bonus for compliance.",
   "abilities": [
    {
     "kind": "endGame",
     "per": "evocationSpells",
     "vp": 2
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.surge_protector_permit",
   "name": "Surge Protector Permit",
   "school": "evocation",
   "formNo": "E-04",
   "price": 3,
   "cost": {
    "red": 1,
    "blue": 2
   },
   "vp": 2,
   "text": "When you visit the Mana Conduit, gain 2 additional {MANA}.",
   "flavor": "Mandatory for any office with more than three lightning rods.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "visit",
      "location": "mana-conduit"
     },
     "effect": [
      {
       "op": "gain",
       "mana": 2
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.grand_evocation_gala",
   "name": "Grand Evocation Gala",
   "school": "evocation",
   "formNo": "E-05",
   "price": 8,
   "cost": {
    "red": 1,
    "yellow": 1,
    "blue": 4
   },
   "vp": 6,
   "text": "No ability — a pure finisher.",
   "flavor": "Formal attire required. Lightning optional but encouraged.",
   "abilities": [],
   "kind": "spell"
  },
  {
   "id": "spell.mandate_of_duplication",
   "name": "Mandate of Duplication",
   "school": "conjuration",
   "formNo": "C-01",
   "price": 3,
   "cost": {
    "red": 2,
    "yellow": 1
   },
   "vp": 2,
   "text": "Once per round, when you gain {R}, gain 1 additional {R}.",
   "flavor": "\"I swear I filed this in triplicate.\" \"Well, file it in quadruplicate just to be safe.\"",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "permitsGained",
      "color": "red"
     },
     "limit": "round",
     "effect": [
      {
       "op": "gain",
       "red": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.hoarders_addendum",
   "name": "Hoarder's Addendum",
   "school": "conjuration",
   "formNo": "C-02",
   "price": 4,
   "cost": {
    "red": 2,
    "green": 2
   },
   "vp": 3,
   "text": "(End Game) Score 1 {VP} for every 4 permits you have left.",
   "flavor": "Clause 11-B allows for \"strategic resource stockpiling\". Don't call it hoarding.",
   "abilities": [
    {
     "kind": "endGame",
     "per": "permitsLeft",
     "every": 4,
     "vp": 1
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.form_g77_golem",
   "name": "Form G-77 \"Golem\"",
   "school": "conjuration",
   "formNo": "C-03",
   "price": 5,
   "cost": {
    "red": 2,
    "yellow": 2
   },
   "vp": 4,
   "v1": {
    "cost": {
     "red": 3,
     "yellow": 2
    }
   },
   "text": "Once per round, as a free action, discard 1 Action card to gain 2 permits of your choice.",
   "flavor": "The standard form for animating an unthinking servant to handle your paperwork.",
   "abilities": [
    {
     "kind": "activated",
     "label": "Discard 1 Action card → gain 2 permits",
     "cost": {
      "discardAction": 1
     },
     "limit": "round",
     "effect": [
      {
       "op": "choosePermits",
       "count": 2
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.summoning_circle_lease",
   "name": "Summoning Circle Lease",
   "school": "conjuration",
   "formNo": "C-04",
   "price": 4,
   "cost": {
    "red": 2,
    "green": 1
   },
   "vp": 2,
   "text": "At the start of each round, gain {R}.",
   "flavor": "Circle rented by the hour. Please return all demons by 5 PM.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "roundStart"
     },
     "effect": [
      {
       "op": "gain",
       "red": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.spontaneous_staffing",
   "name": "Spontaneous Staffing",
   "school": "conjuration",
   "formNo": "C-05",
   "price": 5,
   "cost": {
    "red": 2,
    "yellow": 2,
    "blue": 1
   },
   "vp": 3,
   "v1": {
    "cost": {
     "red": 2,
     "yellow": 1,
     "blue": 1
    }
   },
   "text": "Once per game, as a free action, gain a temporary Assistant and place it this turn.",
   "flavor": "Nobody hired him. He simply appeared, holding a clipboard.",
   "abilities": [
    {
     "kind": "activated",
     "label": "Gain a temporary Assistant",
     "limit": "game",
     "effect": [
      {
       "op": "extraPlacement"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.alchemical_reclassification",
   "name": "Alchemical Reclassification",
   "school": "transmutation",
   "formNo": "T-01",
   "price": 4,
   "cost": {
    "yellow": 2,
    "green": 1
   },
   "vp": 3,
   "text": "Once per round, when you pay a cost, you may pay 1 {Y} as a permit of any colour.",
   "flavor": "Turns lead into gold and, more importantly, a rejected application into an approved one.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "substitute"
     }
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.the_expedited_process",
   "name": "The Expedited Process",
   "school": "transmutation",
   "formNo": "T-02",
   "price": 6,
   "cost": {
    "red": 2,
    "yellow": 1,
    "blue": 2,
    "green": 1
   },
   "vp": 2,
   "v1": {
    "cost": {
     "red": 1,
     "yellow": 1,
     "blue": 1,
     "green": 1
    },
    "vp": 5
   },
   "text": "You gain 1 Assistant, immediately and permanently.",
   "flavor": "A mythical fast-track that costs a fortune, but actually works. Mostly.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "gainAssistant"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.transmogrified_timesheet",
   "name": "Transmogrified Timesheet",
   "school": "transmutation",
   "formNo": "T-03",
   "price": 2,
   "cost": {
    "yellow": 1,
    "blue": 1
   },
   "vp": 1,
   "text": "When you visit the Mana Conduit, also gain {Y}.",
   "flavor": "Hours worked: 8. Hours billed: gold.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "visit",
      "location": "mana-conduit"
     },
     "effect": [
      {
       "op": "gain",
       "yellow": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.amended_classification",
   "name": "Amended Classification",
   "school": "transmutation",
   "formNo": "T-04",
   "price": 4,
   "cost": {
    "yellow": 2,
    "green": 1
   },
   "vp": 2,
   "text": "For City Problem requirements, this spell counts as a spell of every school.",
   "flavor": "Is it a conjuration? A transmutation? Per the amendment, yes.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "countsAsAllSchools"
     }
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.lead_to_gold_ledger",
   "name": "Lead-to-Gold Ledger",
   "school": "transmutation",
   "formNo": "T-05",
   "price": 5,
   "cost": {
    "yellow": 3,
    "blue": 1
   },
   "vp": 4,
   "text": "(End Game) Score 1 {VP} for every 3 {MANA} you have left.",
   "flavor": "Assets are assets. The ledger does not ask where they came from.",
   "abilities": [
    {
     "kind": "endGame",
     "per": "manaLeft",
     "every": 3,
     "vp": 1
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.scry_the_inner_workings",
   "name": "Scry the Inner Workings",
   "school": "divination",
   "formNo": "D-01",
   "price": 3,
   "cost": {
    "green": 3
   },
   "vp": 2,
   "text": "When you visit the Archive, draw 1 additional Action card.",
   "flavor": "Knowing who's about to be promoted is just as important as knowing the future.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "archiveDraw",
      "delta": 1
     }
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.prescient_planning",
   "name": "Prescient Planning",
   "school": "divination",
   "formNo": "D-02",
   "price": 2,
   "cost": {
    "green": 2
   },
   "vp": 1,
   "text": "When you acquire a spell, draw 1 Action card.",
   "flavor": "The greatest power is knowing exactly which form you'll need to fill out next.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "spellAcquired"
     },
     "effect": [
      {
       "op": "draw",
       "n": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.prophetic_price_check",
   "name": "Prophetic Price Check",
   "school": "divination",
   "formNo": "D-03",
   "price": 2,
   "cost": {
    "green": 2
   },
   "vp": 1,
   "text": "Spells cost you 1 less {MANA} at the Arcanium.",
   "flavor": "She knew it would go on sale. She always knows.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "arcaniumPrice",
      "delta": -1
     }
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.clairvoyant_caseload",
   "name": "Clairvoyant Caseload",
   "school": "divination",
   "formNo": "D-04",
   "price": 4,
   "cost": {
    "red": 1,
    "green": 3
   },
   "vp": 1,
   "text": "(End Game) Score 2 {VP} for each City Problem you claimed.",
   "flavor": "The complaint arrived before the problem did. Efficient.",
   "abilities": [
    {
     "kind": "endGame",
     "per": "problemsClaimed",
     "vp": 2
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.omniscient_filing_system",
   "name": "Omniscient Filing System",
   "school": "divination",
   "formNo": "D-05",
   "price": 6,
   "cost": {
    "blue": 2,
    "green": 3
   },
   "vp": 2,
   "text": "Your action hand limit is 8. At the start of each round, draw 1 Action card.",
   "flavor": "Every drawer knows what's in every other drawer. They gossip.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "handLimit",
      "value": 8
     }
    },
    {
     "kind": "trigger",
     "on": {
      "event": "roundStart"
     },
     "effect": [
      {
       "op": "draw",
       "n": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.requisitioned_imp",
   "name": "Requisitioned Imp",
   "school": "conjuration",
   "formNo": "C-06",
   "price": 2,
   "cost": {
    "red": 1,
    "green": 1
   },
   "vp": 1,
   "text": "When you visit the Archive, also gain {R}.",
   "flavor": "Signed out for one fiscal year. Must be returned fed, watered and mostly unsinged.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "visit",
      "location": "archive"
     },
     "effect": [
      {
       "op": "gain",
       "red": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.clone_clause",
   "name": "Clone Clause",
   "school": "conjuration",
   "formNo": "C-07",
   "price": 4,
   "cost": {
    "red": 2,
    "blue": 1
   },
   "vp": 2,
   "text": "When you cast another Conjuration spell, gain 1 permit of your choice.",
   "flavor": "Every summoning now arrives with a signed copy of itself. For the records.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "spellCast",
      "school": "conjuration"
     },
     "effect": [
      {
       "op": "choosePermits",
       "count": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.paperwork_poltergeist",
   "name": "Paperwork Poltergeist",
   "school": "conjuration",
   "formNo": "C-08",
   "price": 3,
   "cost": {
    "red": 2
   },
   "vp": 2,
   "text": "Once per round, as a free action, pay 2 {MANA} to gain {R}{R}.",
   "flavor": "It rattles the filing cabinets until the permits fall out. Very efficient. Very loud.",
   "abilities": [
    {
     "kind": "activated",
     "label": "Pay 2 mana → gain 2 Red permits",
     "cost": {
      "mana": 2
     },
     "limit": "round",
     "effect": [
      {
       "op": "gain",
       "red": 2
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.standing_summons",
   "name": "Standing Summons",
   "school": "conjuration",
   "formNo": "C-09",
   "price": 6,
   "cost": {
    "red": 3,
    "yellow": 1
   },
   "vp": 3,
   "text": "At the start of each round, gain 1 permit of your choice.",
   "flavor": "A permanent order for one (1) permit, delivered by something with too many elbows.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "roundStart"
     },
     "effect": [
      {
       "op": "choosePermits",
       "count": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.legion_of_interns",
   "name": "Legion of Interns",
   "school": "conjuration",
   "formNo": "C-10",
   "price": 7,
   "cost": {
    "red": 3,
    "yellow": 2,
    "blue": 1
   },
   "vp": 5,
   "text": "(End Game) Score 1 {VP} for each Conjuration spell you have cast, including this one.",
   "flavor": "Unpaid, unending and unsettlingly identical. They all answer to \"Kevin\".",
   "abilities": [
    {
     "kind": "endGame",
     "per": "conjurationSpells",
     "vp": 1
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.petty_cash_conversion",
   "name": "Petty Cash Conversion",
   "school": "transmutation",
   "formNo": "T-06",
   "price": 2,
   "cost": {
    "yellow": 1,
    "green": 1
   },
   "vp": 1,
   "text": "Once per round, as a free action, pay 2 {MANA} to gain 1 permit of your choice.",
   "flavor": "Coins in, forms out. The machine has never once given correct change.",
   "abilities": [
    {
     "kind": "activated",
     "label": "Pay 2 mana → gain 1 permit",
     "cost": {
      "mana": 2
     },
     "limit": "round",
     "effect": [
      {
       "op": "choosePermits",
       "count": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.quicksilver_quota",
   "name": "Quicksilver Quota",
   "school": "transmutation",
   "formNo": "T-07",
   "price": 3,
   "cost": {
    "yellow": 2,
    "blue": 1
   },
   "vp": 2,
   "text": "When you cast another Transmutation spell, gain 2 {MANA}.",
   "flavor": "Every conversion leaves a little residue. Accounting calls it \"the good residue\".",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "spellCast",
      "school": "transmutation"
     },
     "effect": [
      {
       "op": "gain",
       "mana": 2
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.gilded_receipt",
   "name": "Gilded Receipt",
   "school": "transmutation",
   "formNo": "T-08",
   "price": 4,
   "cost": {
    "yellow": 2,
    "green": 1
   },
   "vp": 2,
   "text": "Once per round, as a free action, discard up to 2 permits to gain 2 {MANA} for each.",
   "flavor": "Proof of purchase, proof of value, proof that paper is worth its weight in gold.",
   "abilities": [
    {
     "kind": "activated",
     "label": "Discard up to 2 permits → 2 mana each",
     "limit": "round",
     "effect": [
      {
       "op": "liquidate",
       "max": 2,
       "manaEach": 2
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.philosophers_surplus",
   "name": "Philosopher's Surplus",
   "school": "transmutation",
   "formNo": "T-09",
   "price": 5,
   "cost": {
    "red": 1,
    "yellow": 3
   },
   "vp": 3,
   "text": "(End Game) Score 1 {VP} for every 3 permits you have left.",
   "flavor": "The stone was never the point. The point was the storage cupboard behind it.",
   "abilities": [
    {
     "kind": "endGame",
     "per": "permitsLeft",
     "every": 3,
     "vp": 1
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.grand_unified_charter",
   "name": "Grand Unified Charter",
   "school": "transmutation",
   "formNo": "T-10",
   "price": 8,
   "cost": {
    "yellow": 4,
    "blue": 1,
    "green": 1
   },
   "vp": 5,
   "text": "(End Game) Score 1 {VP} for each school you have cast spells of.",
   "flavor": "One form to rule them all. It is four hundred pages long.",
   "abilities": [
    {
     "kind": "endGame",
     "per": "distinctSchools",
     "vp": 1
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.static_stamp",
   "name": "Static Stamp",
   "school": "evocation",
   "formNo": "E-06",
   "price": 2,
   "cost": {
    "blue": 2
   },
   "vp": 1,
   "text": "Once per round, when you visit a Department, gain 1 {MANA}.",
   "flavor": "Every approval comes with a small, bracing shock. Morale has never been higher.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "visit",
      "keyword": "department"
     },
     "limit": "round",
     "effect": [
      {
       "op": "gain",
       "mana": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.thunderclap_filing",
   "name": "Thunderclap Filing",
   "school": "evocation",
   "formNo": "E-07",
   "price": 4,
   "cost": {
    "red": 1,
    "blue": 3
   },
   "vp": 3,
   "text": "When you cast another Evocation spell, gain 1 {VP}.",
   "flavor": "Each form is stamped with a clap of thunder. The Archive has asked for earplugs.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "spellCast",
      "school": "evocation"
     },
     "effect": [
      {
       "op": "gain",
       "vp": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.overcharged_quill",
   "name": "Overcharged Quill",
   "school": "evocation",
   "formNo": "E-08",
   "price": 6,
   "cost": {
    "yellow": 1,
    "blue": 2
   },
   "vp": 2,
   "text": "At the start of each round, gain 2 {MANA}.",
   "flavor": "Writes in lightning. Signs in lightning. Occasionally sets the desk alight.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "roundStart"
     },
     "effect": [
      {
       "op": "gain",
       "mana": 2
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.arc_flash_amendment",
   "name": "Arc Flash Amendment",
   "school": "evocation",
   "formNo": "E-09",
   "price": 6,
   "cost": {
    "blue": 4,
    "green": 1
   },
   "vp": 3,
   "text": "Once per round, as a free action, pay 3 {MANA} to gain 1 {VP}.",
   "flavor": "Turns raw power into raw prestige. Safety goggles strongly recommended.",
   "abilities": [
    {
     "kind": "activated",
     "label": "Pay 3 mana → gain 1 VP",
     "cost": {
      "mana": 3
     },
     "limit": "round",
     "effect": [
      {
       "op": "gain",
       "vp": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.crescendo_clause",
   "name": "Crescendo Clause",
   "school": "evocation",
   "formNo": "E-10",
   "price": 8,
   "cost": {
    "red": 1,
    "yellow": 1,
    "blue": 4
   },
   "vp": 4,
   "text": "(End Game) Score 1 {VP} for every 2 spells you have cast, including this one.",
   "flavor": "Every spell you file adds a note. By the end of the year, it's a symphony.",
   "abilities": [
    {
     "kind": "endGame",
     "per": "spellsCast",
     "every": 2,
     "vp": 1
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.tea_leaf_triage",
   "name": "Tea-Leaf Triage",
   "school": "divination",
   "formNo": "D-06",
   "price": 2,
   "cost": {
    "green": 2
   },
   "vp": 1,
   "text": "When you visit the Archive, draw 1 additional Action card.",
   "flavor": "The leaves said \"Form 12-B\". The leaves are usually right about forms.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "archiveDraw",
      "delta": 1
     }
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.foreseen_footnote",
   "name": "Foreseen Footnote",
   "school": "divination",
   "formNo": "D-07",
   "price": 3,
   "cost": {
    "blue": 1,
    "green": 2
   },
   "vp": 1,
   "text": "When you play an Action card, gain 1 {MANA}.",
   "flavor": "The footnote was written before the memo. The memo is still catching up.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "actionPlayed"
     },
     "effect": [
      {
       "op": "gain",
       "mana": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.augury_of_audits",
   "name": "Augury of Audits",
   "school": "divination",
   "formNo": "D-08",
   "price": 4,
   "cost": {
    "red": 1,
    "green": 3
   },
   "vp": 2,
   "text": "When you claim a City Problem, gain 2 permits of your choice.",
   "flavor": "She saw the crisis coming and filed the paperwork to profit from it. Twice.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "problemClaimed",
      "by": "self"
     },
     "effect": [
      {
       "op": "choosePermits",
       "count": 2
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.memoirs_of_the_future",
   "name": "Memoirs of the Future",
   "school": "divination",
   "formNo": "D-09",
   "price": 5,
   "cost": {
    "yellow": 1,
    "green": 3
   },
   "vp": 2,
   "text": "(End Game) Score 1 {VP} for every 2 Action cards you have played.",
   "flavor": "Chapter 7 describes your next meeting in excruciating, accurate detail.",
   "abilities": [
    {
     "kind": "endGame",
     "per": "actionCardsPlayed",
     "every": 2,
     "vp": 1
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.oracles_omnibus",
   "name": "Oracle's Omnibus",
   "school": "divination",
   "formNo": "D-10",
   "price": 7,
   "cost": {
    "red": 1,
    "yellow": 1,
    "green": 4
   },
   "vp": 3,
   "text": "Once per round, when you play an Action card, gain 1 {VP}.",
   "flavor": "Every prophecy ever filed, bound in one volume. The index alone is load-bearing.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "actionPlayed"
     },
     "limit": "round",
     "effect": [
      {
       "op": "gain",
       "vp": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.open_plan_ordinance",
   "name": "Open-Plan Ordinance",
   "school": "conjuration",
   "formNo": "C-11",
   "price": 5,
   "cost": {
    "red": 2,
    "blue": 1
   },
   "vp": 2,
   "text": "When cast, enact Open-Plan Office — every location holds 1 more Assistant.",
   "flavor": "Summoned a larger office. The walls are still arriving.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "enact",
       "decree": "decree.open_plan_office"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.hot_desk_familiar",
   "name": "Hot-Desk Familiar",
   "school": "conjuration",
   "formNo": "C-12",
   "price": 4,
   "cost": {
    "red": 2,
    "green": 1
   },
   "vp": 1,
   "text": "Once per round, when a rival visits a Department, gain 1 permit that Department gives.",
   "flavor": "It sits at whichever desk is warmest and copies everything on it.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "rivalVisit",
      "keyword": "department"
     },
     "limit": "round",
     "effect": [
      {
       "op": "choosePermits",
       "count": 1,
       "colors": "locationGives"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.public_stipend_charter",
   "name": "Public Stipend Charter",
   "school": "conjuration",
   "formNo": "C-13",
   "price": 4,
   "cost": {
    "red": 2,
    "green": 1
   },
   "vp": 1,
   "text": "When cast, enact Public Stipend — every player gains 1 more {MANA} at the start of each round.",
   "flavor": "Conjured from the Treasury's rainy-day fund. It was raining.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "enact",
       "decree": "decree.public_stipend"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.subpoena_imp",
   "name": "Subpoena Imp",
   "school": "conjuration",
   "formNo": "C-14",
   "price": 4,
   "cost": {
    "red": 2,
    "yellow": 1
   },
   "vp": 2,
   "text": "When you visit the Archive, also take a random Action card from a rival's hand.",
   "flavor": "It serves papers. Mostly it serves itself to other people's papers.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "visit",
      "location": "archive"
     },
     "effect": [
      {
       "op": "stealAction"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.streamlined_forms_act",
   "name": "Streamlined Forms Act",
   "school": "transmutation",
   "formNo": "T-11",
   "price": 6,
   "cost": {
    "yellow": 2,
    "blue": 1,
    "green": 1
   },
   "vp": 2,
   "text": "When cast, enact Streamlined Forms — every spell costs 1 fewer permit of its school's colour (min 1).",
   "flavor": "Transmutes twelve pages of red tape into one page of slightly pink tape.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "enact",
       "decree": "decree.streamlined_forms"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.price_control_directive",
   "name": "Price Control Directive",
   "school": "transmutation",
   "formNo": "T-12",
   "price": 3,
   "cost": {
    "yellow": 2
   },
   "vp": 1,
   "text": "When cast, enact Price Controls — Arcanium spells cost 1 less {MANA}.",
   "flavor": "Every price tag in the Arcanium now reads \"reasonable\". Some of them are lying.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "enact",
       "decree": "decree.price_controls"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.diplomatic_seal",
   "name": "Diplomatic Seal",
   "school": "transmutation",
   "formNo": "T-13",
   "price": 4,
   "cost": {
    "red": 1,
    "yellow": 2
   },
   "vp": 2,
   "text": "Rivals cannot put your spells Under Review, Revoke them, or Repeal your Decrees.",
   "flavor": "Sealed, stamped and transmuted into something no court can lift.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "appealImmune"
     }
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.arcanium_levy_statute",
   "name": "Arcanium Levy Statute",
   "school": "transmutation",
   "formNo": "T-14",
   "price": 5,
   "cost": {
    "yellow": 3,
    "blue": 1
   },
   "vp": 2,
   "text": "When cast, enact Arcanium Levy — a rival visiting the Arcanium pays you 1 {MANA}.",
   "flavor": "Every sale turns a little of the customer's gold into yours.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "enact",
       "decree": "decree.arcanium_levy"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.conduit_toll_warrant",
   "name": "Conduit Toll Warrant",
   "school": "evocation",
   "formNo": "E-11",
   "price": 5,
   "cost": {
    "red": 1,
    "blue": 3
   },
   "vp": 2,
   "text": "When cast, enact Conduit Toll — a rival visiting the Mana Conduit pays you 1 {MANA}.",
   "flavor": "The Conduit hums a little louder when it's making you money.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "enact",
       "decree": "decree.conduit_toll"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.brownout_proclamation",
   "name": "Brownout Proclamation",
   "school": "evocation",
   "formNo": "E-12",
   "price": 4,
   "cost": {
    "yellow": 1,
    "blue": 2
   },
   "vp": 2,
   "text": "When cast, enact Mana Rationing — the Mana Conduit gives 1 less {MANA}.",
   "flavor": "Lights out at nine. Spellcasting by candle only. Candles by permit only.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "enact",
       "decree": "decree.mana_rationing"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.storm_levy",
   "name": "Storm Levy",
   "school": "evocation",
   "formNo": "E-13",
   "price": 4,
   "cost": {
    "red": 1,
    "blue": 2
   },
   "vp": 2,
   "text": "When cast, each rival pays you 1 {MANA}. Each rival with more {VP} than you pays 1 more.",
   "flavor": "Thunder rolls over every counting-house in the city. The coins come running.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "levy",
       "mana": 1,
       "from": "all"
      },
      {
       "op": "levy",
       "mana": 1,
       "from": "leaders"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.lightning_rod_clause",
   "name": "Lightning Rod Clause",
   "school": "evocation",
   "formNo": "E-14",
   "price": 3,
   "cost": {
    "blue": 2
   },
   "vp": 1,
   "text": "Once per round, when a rival casts a spell, gain 1 {MANA}.",
   "flavor": "Every flash of magic in the building finds its way, eventually, to your desk.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "rivalCast"
     },
     "limit": "round",
     "effect": [
      {
       "op": "gain",
       "mana": 1
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.writ_of_review",
   "name": "Writ of Review",
   "school": "divination",
   "formNo": "D-11",
   "price": 4,
   "cost": {
    "yellow": 1,
    "green": 2
   },
   "vp": 2,
   "text": "When cast, put a rival's spell Under Review — its abilities stop until the end of next round.",
   "flavor": "Foreseen: a clerical irregularity. Also foreseen: a very long hearing.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "suspend"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.open_records_mandate",
   "name": "Open Records Mandate",
   "school": "divination",
   "formNo": "D-12",
   "price": 4,
   "cost": {
    "red": 1,
    "green": 2
   },
   "vp": 2,
   "text": "When cast, enact Open Records — the Archive draws 1 more Action card.",
   "flavor": "The seers were going to read it all anyway. Now it's official.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "enact",
       "decree": "decree.open_records"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.civic_bonus_bulletin",
   "name": "Civic Bonus Bulletin",
   "school": "divination",
   "formNo": "D-13",
   "price": 5,
   "cost": {
    "yellow": 1,
    "green": 3
   },
   "vp": 2,
   "text": "When cast, enact Civic Bonus Scheme — every City Problem is worth 1 more {VP}.",
   "flavor": "Printed before the problems happened. Distributed after. Accurate throughout.",
   "abilities": [
    {
     "kind": "onCast",
     "effect": [
      {
       "op": "enact",
       "decree": "decree.civic_bonus"
      }
     ]
    }
   ],
   "kind": "spell"
  },
  {
   "id": "spell.eavesdroppers_almanac",
   "name": "Eavesdropper's Almanac",
   "school": "divination",
   "formNo": "D-14",
   "price": 3,
   "cost": {
    "blue": 1,
    "green": 2
   },
   "vp": 1,
   "text": "Once per round, when a rival visits the Archive or Planning Office, draw 1 Action card.",
   "flavor": "Every page is a conversation you weren't in. Every margin, a note you shouldn't have.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "rivalVisit",
      "keyword": "records"
     },
     "limit": "round",
     "effect": [
      {
       "op": "draw",
       "n": 1
      }
     ]
    }
   ],
   "kind": "spell"
  }
 ],
 "actions": [
  {
   "id": "action.misfiled_forms",
   "name": "\"Misfiled\" Forms",
   "copies": 3,
   "text": "Gain 2 permits of your choice.",
   "flavor": "\"Finders keepers, losers weepers.\" (The Archive motto)",
   "effect": [
    {
     "op": "choosePermits",
     "count": 2
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.overtime_shift",
   "name": "Overtime Shift",
   "copies": 2,
   "text": "Choose a Department where you have an Assistant. Resolve that Department's effect again.",
   "flavor": "\"The arcane energies don't stop at 5 PM, and neither do we.\"",
   "effect": [
    {
     "op": "resolveOwnDepartment"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.bureaucratic_slipstream",
   "name": "Bureaucratic Slipstream",
   "copies": 3,
   "text": "Gain 3 {MANA}.",
   "flavor": "\"Sometimes the system has a rounding error in your favour. Don't ask questions.\"",
   "effect": [
    {
     "op": "gain",
     "mana": 3
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.requisition_priority",
   "name": "Requisition Priority",
   "copies": 2,
   "text": "Clear the Arcanium and reveal 5 new spells. Then you may buy 1 spell from it.",
   "flavor": "\"I'd like to file a motion to refresh this establishment's inventory. Effective immediately.\"",
   "effect": [
    {
     "op": "refreshArcanium"
    },
    {
     "op": "buySpell"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.interdepartmental_memo",
   "name": "Interdepartmental Memo",
   "copies": 2,
   "text": "Choose another player. Exchange 1 of your permits for 1 of theirs; you choose both colours.",
   "flavor": "\"Per my last incantation…\"",
   "effect": [
    {
     "op": "exchangePermits"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.audit",
   "name": "Audit",
   "copies": 2,
   "text": "Choose a location. Other players cannot place Assistants there this round.",
   "flavor": "\"Just a routine inspection. Nothing to see here, folks. Move along.\"",
   "effect": [
    {
     "op": "block"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.liquidate_assets",
   "name": "Liquidate Assets",
   "copies": 2,
   "text": "Discard up to 3 permits of any colours. Gain 2 {MANA} for each.",
   "flavor": "\"Turning paper into power. Literally.\"",
   "effect": [
    {
     "op": "liquidate",
     "max": 3,
     "manaEach": 2
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.archival_deep_dive",
   "name": "Archival Deep-Dive",
   "copies": 2,
   "text": "Draw 2 Action cards, then discard 1 Action card from your hand.",
   "flavor": "\"There's a fine line between research and getting lost in the stacks.\"",
   "effect": [
    {
     "op": "draw",
     "n": 2
    },
    {
     "op": "discardActions",
     "count": 1
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.legal_precedent",
   "name": "Legal Precedent",
   "copies": 2,
   "text": "The next spell you cast this round costs 1 fewer permit of your choice.",
   "flavor": "\"As established in Wizard v. A Slightly Singed Ogre, we are well within our rights.\"",
   "effect": [
    {
     "op": "modifier",
     "kind": "nextSpellDiscount",
     "amount": 1
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.emergency_sanction",
   "name": "Emergency Sanction",
   "copies": 1,
   "text": "Gain a temporary Assistant. You may place it this turn as an additional placement.",
   "flavor": "\"Break glass in case of magical emergency. Or, you know, just file the right form.\"",
   "effect": [
    {
     "op": "extraPlacement"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.notarized_copy",
   "name": "Notarized Copy",
   "copies": 2,
   "text": "Choose a Department where another player has an Assistant. Gain that Department's effect.",
   "flavor": "Certified true copy. The original is, regrettably, busy.",
   "effect": [
    {
     "op": "copyOtherDepartment"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.clerical_error",
   "name": "Clerical Error",
   "copies": 2,
   "text": "Swap 1 spell in your hand with 1 spell in the Arcanium.",
   "flavor": "Nobody noticed. Nobody ever notices.",
   "effect": [
    {
     "op": "swapSpell"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.discount_voucher",
   "name": "Discount Voucher",
   "copies": 2,
   "text": "Your next Arcanium purchase this round costs 2 less {MANA}.",
   "flavor": "Valid until 5 PM. Not valid with other vouchers, curses or hexes.",
   "effect": [
    {
     "op": "modifier",
     "kind": "nextPurchaseDiscount",
     "amount": 2
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.rubber_stamped_resolution",
   "name": "Rubber-Stamped Resolution",
   "copies": 1,
   "text": "Claim 1 City Problem whose requirement you meet, as if at the Grand Auditor's Office.",
   "flavor": "Pre-approved. Post-dated. Perfectly legal.",
   "effect": [
    {
     "op": "claimProblem"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.budget_surplus",
   "name": "Budget Surplus",
   "copies": 2,
   "text": "Gain 2 {MANA} and draw 1 Action card.",
   "flavor": "Spend it before anyone notices it's there.",
   "effect": [
    {
     "op": "gain",
     "mana": 2
    },
    {
     "op": "draw",
     "n": 1
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.rush_order",
   "name": "Rush Order",
   "copies": 2,
   "text": "Buy 1 spell from the Arcanium. It costs 1 less {MANA}.",
   "flavor": "\"Paid extra for next-day enchantment. It arrived yesterday.\"",
   "effect": [
    {
     "op": "buySpell",
     "discount": 1
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.petty_cash",
   "name": "Petty Cash",
   "copies": 2,
   "text": "Gain 1 {MANA} and 1 permit of your choice.",
   "flavor": "\"Nobody ever audits the jar marked Miscellaneous.\"",
   "effect": [
    {
     "op": "gain",
     "mana": 1
    },
    {
     "op": "choosePermits",
     "count": 1
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.commendation",
   "name": "Commendation",
   "copies": 2,
   "text": "Gain 2 {VP}.",
   "flavor": "\"A gold star from the Deputy Hexecutive. Laminated, for posterity.\"",
   "effect": [
    {
     "op": "gain",
     "vp": 2
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.writ_of_appeal",
   "name": "Writ of Appeal",
   "copies": 2,
   "text": "Put a rival's spell Under Review — its abilities stop until the end of next round.",
   "flavor": "\"The Ministry has received a complaint. The Ministry has, in fact, written it.\"",
   "effect": [
    {
     "op": "suspend"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.motion_to_repeal",
   "name": "Motion to Repeal",
   "copies": 2,
   "text": "Repeal 1 Decree in force. Then gain 2 {MANA}.",
   "flavor": "All in favour? The ayes have it. The Decree has been fed to the shredder.",
   "effect": [
    {
     "op": "repeal"
    },
    {
     "op": "gain",
     "mana": 2
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.emergency_ordinance",
   "name": "Emergency Ordinance",
   "copies": 2,
   "text": "Enact Expedited Planning — the Planning Office plays 1 more Action card.",
   "flavor": "Passed in the corridor, signed on a knee, effective immediately.",
   "effect": [
    {
     "op": "enact",
     "decree": "decree.expedited_planning"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.paper_shortage_notice",
   "name": "Paper Shortage Notice",
   "copies": 1,
   "text": "Enact Paper Shortage — every player's Action hand limit is 2 lower.",
   "flavor": "Printed on the last sheet in the building. Twice.",
   "effect": [
    {
     "op": "enact",
     "decree": "decree.paper_shortage"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.writ_of_revocation",
   "name": "Writ of Revocation",
   "copies": 1,
   "text": "Return a spell cast by a rival with at least as many {VP} as you to their hand. They lose its printed {VP}.",
   "flavor": "Your licence has been reviewed, revised, rescinded and returned. With a smiley face.",
   "effect": [
    {
     "op": "revoke"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.subpoena",
   "name": "Subpoena",
   "copies": 2,
   "text": "Take a random Action card from a rival's hand.",
   "flavor": "You are hereby summoned to hand over whatever you were hiding. Thank you for your cooperation.",
   "effect": [
    {
     "op": "stealAction"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.tax_assessment",
   "name": "Tax Assessment",
   "copies": 2,
   "text": "Each rival with more {VP} than you pays you 2 {MANA}.",
   "flavor": "Success, the Ministry notes, is a taxable event.",
   "effect": [
    {
     "op": "levy",
     "mana": 2,
     "from": "leaders"
    }
   ],
   "kind": "action"
  },
  {
   "id": "action.public_holiday",
   "name": "Public Holiday",
   "copies": 2,
   "text": "Every player gains 2 {MANA}. You also gain 1 permit of your choice.",
   "flavor": "Declared at noon, retroactive to breakfast. The whole Ministry cheers; you cheer loudest.",
   "effect": [
    {
     "op": "allGain",
     "mana": 2
    },
    {
     "op": "choosePermits",
     "count": 1
    }
   ],
   "kind": "action"
  }
 ],
 "problems": [
  {
   "id": "problem.cacophonous_clocktower",
   "name": "The Cacophonous Clocktower",
   "description": "Chiming at random, deafening intervals because of a misaligned temporal spring.",
   "text": "Have cast 2+ Evocation spells.",
   "requirement": {
    "castSchool": {
     "school": "evocation",
     "atLeast": 2
    }
   },
   "tiers": [
    8,
    4
   ],
   "resolution": "resolution.storm_power",
   "kind": "problem"
  },
  {
   "id": "problem.golem_traffic_jam",
   "name": "Golem Traffic Jam",
   "description": "An army of clay golems, all following the same contradictory order.",
   "text": "Have cast 2+ Conjuration spells.",
   "requirement": {
    "castSchool": {
     "school": "conjuration",
     "atLeast": 2
    }
   },
   "tiers": [
    8,
    4
   ],
   "resolution": "resolution.morning_rush",
   "kind": "problem"
  },
  {
   "id": "problem.polymorphed_public_statues",
   "name": "Polymorphed Public Statues",
   "description": "The city statues have been transmuted into sentient, complaining pigeons.",
   "text": "Have cast 2+ Transmutation spells.",
   "requirement": {
    "castSchool": {
     "school": "transmutation",
     "atLeast": 2
    }
   },
   "tiers": [
    8,
    4
   ],
   "kind": "problem"
  },
  {
   "id": "problem.prophecy_of_perpetual_rain",
   "name": "The Prophecy of Perpetual Rain",
   "description": "A runaway divination has forecast endless gloom.",
   "text": "Have cast 2+ Divination spells.",
   "requirement": {
    "castSchool": {
     "school": "divination",
     "atLeast": 2
    }
   },
   "tiers": [
    8,
    4
   ],
   "resolution": "resolution.open_shelves",
   "kind": "problem"
  },
  {
   "id": "problem.unstable_portal",
   "name": "Unstable Portal in the Central Market",
   "description": "Spitting exotic (and aggressive) fauna into the busiest market.",
   "text": "Have cast spells of 3+ different schools.",
   "requirement": {
    "distinctSchools": 3
   },
   "tiers": [
    12,
    6
   ],
   "resolution": "resolution.night_market",
   "kind": "problem"
  },
  {
   "id": "problem.great_paper_jam",
   "name": "The Great Paper Jam",
   "description": "Every printing press in the Ministry has seized at once.",
   "text": "Fee: pay {R}{R}{Y}{Y}.",
   "fee": {
    "permits": {
     "red": 2,
     "yellow": 2
    }
   },
   "tiers": [
    5,
    3
   ],
   "resolution": "resolution.memos_fly_free",
   "kind": "problem"
  },
  {
   "id": "problem.rogue_weather_charm",
   "name": "Rogue Weather Charm",
   "description": "It is snowing indoors. Only indoors.",
   "text": "Fee: pay {B}{B}{B}{G}{G}{G}.",
   "fee": {
    "permits": {
     "blue": 3,
     "green": 3
    }
   },
   "tiers": [
    5,
    3
   ],
   "resolution": "resolution.magical_weather",
   "kind": "problem"
  },
  {
   "id": "problem.midnight_budget_crisis",
   "name": "Midnight Budget Crisis",
   "description": "The quarterly budget was filed in the wrong quarter.",
   "text": "Fee: pay 7 {MANA}.",
   "fee": {
    "mana": 7
   },
   "tiers": [
    5,
    3
   ],
   "resolution": "resolution.currency_reform",
   "kind": "problem"
  },
  {
   "id": "problem.stampede_of_sentient_stamps",
   "name": "Stampede of Sentient Stamps",
   "description": "The rubber stamps have unionised and are approving everything.",
   "text": "Have cast 4+ spells.",
   "requirement": {
    "spellsCast": 4
   },
   "tiers": [
    8,
    4
   ],
   "resolution": "resolution.stamps_rounded_up",
   "kind": "problem"
  },
  {
   "id": "problem.leaking_ley_line_main",
   "name": "Leaking Ley-Line Main",
   "description": "Raw mana is pooling in the basement and the filing cabinets are drinking it.",
   "text": "Have cast spells with a total printed {VP} of 10+.",
   "requirement": {
    "totalPrintedVp": 10
   },
   "tiers": [
    7,
    4
   ],
   "kind": "problem"
  },
  {
   "id": "problem.haunted_filing_cabinets",
   "name": "Haunted Filing Cabinets",
   "description": "Drawer 13 moans whenever someone requests Form 13.",
   "text": "Have played 4+ Action cards this game.",
   "requirement": {
    "stat": {
     "name": "actionCardsPlayed",
     "atLeast": 4
    }
   },
   "tiers": [
    6,
    3
   ],
   "resolution": "resolution.confidential_waste",
   "kind": "problem"
  },
  {
   "id": "problem.ministry_wide_inventory_audit",
   "name": "Ministry-Wide Inventory Audit",
   "description": "Every permit must be accounted for, in person, by lunchtime.",
   "text": "Have at least 2 permits of every colour. You keep them.",
   "requirement": {
    "permitsEach": 2
   },
   "tiers": [
    6,
    3
   ],
   "resolution": "resolution.foreign_exchange",
   "kind": "problem"
  },
  {
   "id": "problem.great_inkwell_flood",
   "name": "The Great Inkwell Flood",
   "description": "Every inkwell in the Ministry overflowed at once. The carpets are now legally binding.",
   "text": "Fee: pay {B}{B}{G}{G} and 2 {MANA}.",
   "fee": {
    "permits": {
     "blue": 2,
     "green": 2
    },
    "mana": 2
   },
   "tiers": [
    6,
    3
   ],
   "resolution": "resolution.post_delivered",
   "kind": "problem"
  },
  {
   "id": "problem.bureau_of_lost_things",
   "name": "The Bureau of Lost Things",
   "description": "Someone lost the Bureau. It was last seen filing itself under \"Miscellaneous\".",
   "text": "Have bought 3+ spells at the Arcanium.",
   "requirement": {
    "stat": {
     "name": "spellsBought",
     "atLeast": 3
    }
   },
   "tiers": [
    6,
    3
   ],
   "resolution": "resolution.lost_and_found",
   "kind": "problem"
  },
  {
   "id": "problem.departmental_gridlock",
   "name": "Departmental Gridlock",
   "description": "Six departments, one corridor, and nobody will yield to a senior clerk.",
   "text": "Have visited 4+ different Departments.",
   "requirement": {
    "stat": {
     "name": "departmentsVisited",
     "atLeast": 4
    }
   },
   "tiers": [
    6,
    3
   ],
   "resolution": "resolution.labour_accord",
   "kind": "problem"
  },
  {
   "id": "problem.treasury_sinkhole",
   "name": "Sinkhole in the Treasury",
   "description": "The vault floor gave way. The gold is fine; the floor is demanding compensation.",
   "text": "Fee: pay 9 {MANA}.",
   "fee": {
    "mana": 9
   },
   "tiers": [
    7,
    4
   ],
   "resolution": "resolution.ceremonial_stipend",
   "kind": "problem"
  },
  {
   "id": "problem.grand_petition",
   "name": "The Grand Petition",
   "description": "Ten thousand signatures, each demanding something different. Urgently.",
   "text": "Have cast 6+ spells.",
   "requirement": {
    "spellsCast": 6
   },
   "tiers": [
    10,
    5
   ],
   "resolution": "resolution.early_closing",
   "kind": "problem"
  },
  {
   "id": "problem.fog_of_forms",
   "name": "Fog of Forms",
   "description": "A thick mist of loose paperwork has settled over the Old Quarter.",
   "text": "Fee: pay {R}{Y}{B}{G} and 1 {MANA}.",
   "fee": {
    "permits": {
     "red": 1,
     "yellow": 1,
     "blue": 1,
     "green": 1
    },
    "mana": 1
   },
   "tiers": [
    5,
    3
   ],
   "resolution": "resolution.fog_lifts",
   "kind": "problem"
  },
  {
   "id": "problem.legislative_session",
   "name": "The Endless Legislative Session",
   "description": "The Council has been in session for nine years. Someone must pass something.",
   "text": "Have enacted 2+ Decrees.",
   "requirement": {
    "stat": {
     "name": "decreesEnacted",
     "atLeast": 2
    }
   },
   "tiers": [
    6,
    3
   ],
   "kind": "problem"
  },
  {
   "id": "problem.appeals_backlog",
   "name": "The Appeals Backlog",
   "description": "The court's in-tray has developed its own weather system.",
   "text": "Have filed an Appeal (Under Review or Revoke).",
   "requirement": {
    "stat": {
     "name": "appealsFiled",
     "atLeast": 1
    }
   },
   "tiers": [
    4,
    2
   ],
   "resolution": "resolution.complaints_upheld",
   "kind": "problem"
  },
  {
   "id": "problem.toll_road_dispute",
   "name": "The Toll Road Dispute",
   "description": "Every bridge in the Old Quarter now charges a fee to cross the other bridges.",
   "text": "Have collected 3+ {MANA} from rivals.",
   "requirement": {
    "stat": {
     "name": "manaCollected",
     "atLeast": 3
    }
   },
   "tiers": [
    5,
    3
   ],
   "resolution": "resolution.free_roads",
   "kind": "problem"
  }
 ],
 "identities": [
  {
   "id": "identity.margot_longquill",
   "name": "Margot Longquill",
   "faction": "ministry",
   "role": "Rising star",
   "abilityName": "Efficient Filing",
   "text": "Once per round, when you cast a spell, you may pay 1 {MANA} in place of 1 permit.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "manaForPermit"
     }
    }
   ],
   "package": {
    "name": "Fast-Track Folder",
    "permits": {
     "red": 1,
     "blue": 1
    }
   },
   "kind": "identity"
  },
  {
   "id": "identity.elijah_bramble",
   "name": "Elijah Bramble",
   "faction": "ministry",
   "role": "Earnest assistant",
   "abilityName": "Subclause Specialist",
   "text": "Once per round, when you visit a Department, gain 1 additional permit of a colour that Department gives.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "visit",
      "keyword": "department"
     },
     "limit": "round",
     "effect": [
      {
       "op": "choosePermits",
       "count": 1,
       "colors": "locationGives"
      }
     ]
    }
   ],
   "package": {
    "name": "Neat Stack of Forms",
    "permits": {
     "blue": 1
    }
   },
   "kind": "identity"
  },
  {
   "id": "identity.harlan_quib",
   "name": "Harlan Quib",
   "faction": "ministry",
   "role": "Political rival",
   "abilityName": "Connections",
   "text": "Once per round, you may place an Assistant at a full location.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "ignoreCapacity"
     }
    }
   ],
   "package": {
    "name": "Favours Owed",
    "permits": {
     "blue": 1,
     "green": 1
    },
    "choice": 2,
    "actions": 2
   },
   "kind": "identity"
  },
  {
   "id": "identity.quentillus_draft",
   "name": "Master Quentillus Draft",
   "faction": "ministry",
   "role": "Eccentric mentor",
   "abilityName": "Encyclopedic",
   "text": "When you visit the Archive, draw 1 additional Action card. Your action hand limit is 7.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "archiveDraw",
      "delta": 1
     }
    },
    {
     "kind": "modifier",
     "mod": {
      "type": "handLimit",
      "value": 7
     }
    }
   ],
   "package": {
    "name": "Mentor's Reading List",
    "permits": {
     "red": 1,
     "yellow": 1,
     "blue": 1,
     "green": 2
    },
    "actions": 1
   },
   "kind": "identity"
  },
  {
   "id": "identity.ophelia_scraw",
   "name": "Ophelia Scraw",
   "faction": "ministry",
   "role": "Prefect of Subsectional Integrity",
   "abilityName": "Pedantic Review",
   "text": "Whenever another player claims a City Problem, gain 1 permit of your choice.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "problemClaimed",
      "by": "other"
     },
     "effect": [
      {
       "op": "choosePermits",
       "count": 1
      }
     ]
    }
   ],
   "package": {
    "name": "Inspection Kit",
    "permits": {
     "red": 1,
     "yellow": 1
    }
   },
   "kind": "identity"
  },
  {
   "id": "identity.tamsin_wick",
   "name": "Tamsin Wick",
   "faction": "ministry",
   "role": "Apprentice auditor",
   "abilityName": "Diligent Review",
   "text": "When you visit the Grand Auditor's Office, gain 2 {MANA}. City Problems you claim give +1 {VP}.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "visit",
      "location": "grand-auditor"
     },
     "effect": [
      {
       "op": "gain",
       "mana": 2
      }
     ]
    },
    {
     "kind": "modifier",
     "mod": {
      "type": "problemVp",
      "delta": 1
     }
    }
   ],
   "package": {
    "name": "Audit Sample Set",
    "permits": {
     "red": 1,
     "yellow": 1,
     "green": 2
    }
   },
   "kind": "identity"
  },
  {
   "id": "identity.mistress_pallivane",
   "name": "Mistress Pallivane",
   "faction": "ministry",
   "role": "Minister of Denials",
   "abilityName": "Stamp of Disapproval",
   "text": "Once per round, as a free action, you may pay 3 {MANA} to Audit a location.",
   "abilities": [
    {
     "kind": "activated",
     "label": "Pay 3 mana → Audit a location",
     "cost": {
      "mana": 3
     },
     "limit": "round",
     "effect": [
      {
       "op": "block"
      }
     ]
    }
   ],
   "package": {
    "name": "Denial Kit",
    "permits": {
     "yellow": 1,
     "blue": 1,
     "green": 1
    },
    "choice": 1,
    "actions": 1,
    "mana": 3
   },
   "kind": "identity"
  },
  {
   "id": "identity.rollo_penumbra",
   "name": "Rollo Penumbra",
   "faction": "unfiled",
   "role": "Charming operative",
   "abilityName": "Forged Permits",
   "text": "Once per round, as a free action, you may pay 2 {MANA} to gain 1 permit of any colour.",
   "abilities": [
    {
     "kind": "activated",
     "label": "Pay 2 mana → gain 1 permit",
     "cost": {
      "mana": 2
     },
     "limit": "round",
     "effect": [
      {
       "op": "choosePermits",
       "count": 1
      }
     ]
    }
   ],
   "package": {
    "name": "Forged Paperwork",
    "permits": {
     "blue": 1,
     "green": 1
    },
    "choice": 2
   },
   "kind": "identity"
  },
  {
   "id": "identity.urbanus_glyph",
   "name": "Urbanus Glyph",
   "faction": "unfiled",
   "role": "Graffiti artist",
   "abilityName": "Street Flourish",
   "text": "The first spell you cast each round gives +1 {VP}.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "firstSpellEachRoundVp",
      "delta": 1
     }
    }
   ],
   "package": {
    "name": "Spray-Can Set",
    "permits": {
     "red": 1
    },
    "choice": 1
   },
   "kind": "identity"
  },
  {
   "id": "identity.the_archivox",
   "name": "The Archivox",
   "faction": "unfiled",
   "role": "Leader, identity unknown",
   "abilityName": "Last Original Form",
   "text": "Once per game, cast a spell from your hand ignoring its permit cost.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "freeCast"
     }
    }
   ],
   "package": {
    "name": "Blank Letterhead",
    "choice": 1
   },
   "kind": "identity"
  },
  {
   "id": "identity.bartholomew_tallow",
   "name": "Bartholomew Tallow",
   "faction": "ministry",
   "role": "Night-shift lamplighter",
   "abilityName": "Burning the Midnight Oil",
   "text": "At the start of each round, gain 1 {MANA}. When you visit the Mana Conduit, gain 1 additional {MANA}.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "roundStart"
     },
     "effect": [
      {
       "op": "gain",
       "mana": 1
      }
     ]
    },
    {
     "kind": "trigger",
     "on": {
      "event": "visit",
      "location": "mana-conduit"
     },
     "effect": [
      {
       "op": "gain",
       "mana": 1
      }
     ]
    }
   ],
   "package": {
    "name": "Night-Shift Leftovers",
    "permits": {
     "red": 1,
     "yellow": 1,
     "green": 1
    }
   },
   "kind": "identity"
  },
  {
   "id": "identity.mortimer_blotch",
   "name": "Mortimer Blotch",
   "faction": "unfiled",
   "role": "Ink forger",
   "abilityName": "Double Entry",
   "text": "Once per round, when you cast a spell, gain 1 permit of your choice.",
   "abilities": [
    {
     "kind": "trigger",
     "on": {
      "event": "spellCast"
     },
     "limit": "round",
     "effect": [
      {
       "op": "choosePermits",
       "count": 1
      }
     ]
    }
   ],
   "package": {
    "name": "Ink Reserve",
    "permits": {
     "yellow": 1
    }
   },
   "kind": "identity"
  },
  {
   "id": "identity.grizelda_vex",
   "name": "Grizelda Vex",
   "faction": "ministry",
   "role": "Inspector-General",
   "abilityName": "Surprise Inspection",
   "text": "Once per round, as a free action, pay 3 {MANA} to put a rival's spell Under Review and gain 1 {VP}.",
   "abilities": [
    {
     "kind": "activated",
     "label": "Pay 3 mana → put a rival's spell Under Review, +1 VP",
     "cost": {
      "mana": 3
     },
     "limit": "round",
     "effect": [
      {
       "op": "suspend"
      },
      {
       "op": "gain",
       "vp": 1
      }
     ]
    }
   ],
   "package": {
    "name": "Inspector's Expenses",
    "permits": {
     "red": 1,
     "blue": 1,
     "green": 1
    },
    "actions": 1,
    "mana": 3
   },
   "kind": "identity"
  },
  {
   "id": "identity.pemberton_fogg",
   "name": "Pemberton Fogg",
   "faction": "unfiled",
   "role": "Back-room lobbyist",
   "abilityName": "Friends in the Council",
   "text": "Your Decrees in force score 2 more {VP} each at game end. Once per game, as a free action, Repeal a Decree.",
   "abilities": [
    {
     "kind": "modifier",
     "mod": {
      "type": "decreeVp",
      "delta": 2
     }
    },
    {
     "kind": "activated",
     "label": "Repeal a Decree",
     "limit": "game",
     "effect": [
      {
       "op": "repeal"
      }
     ]
    }
   ],
   "package": {
    "name": "Lobbying Portfolio",
    "permits": {
     "red": 1,
     "yellow": 1,
     "blue": 1
    }
   },
   "kind": "identity"
  }
 ],
 "agendas": [
  {
   "id": "agenda.departmental_loyalist",
   "name": "Departmental Loyalist",
   "text": "You visited the same Department in 5 different rounds.",
   "condition": {
    "stat": "sameDepartmentRounds",
    "atLeast": 5
   },
   "vp": 5,
   "kind": "agenda"
  },
  {
   "id": "agenda.paper_trail",
   "name": "Paper Trail",
   "text": "You visited all six Departments at least once.",
   "condition": {
    "stat": "departmentsVisited",
    "atLeast": 6
   },
   "vp": 5,
   "kind": "agenda"
  },
  {
   "id": "agenda.specialist_certification",
   "name": "Specialist Certification",
   "text": "You have cast 3+ spells of one school.",
   "condition": {
    "stat": "maxSchoolCount",
    "atLeast": 3
   },
   "vp": 5,
   "kind": "agenda"
  },
  {
   "id": "agenda.well_rounded_resume",
   "name": "Well-Rounded Résumé",
   "text": "You have cast spells of all four schools.",
   "condition": {
    "stat": "distinctSchools",
    "atLeast": 4
   },
   "vp": 6,
   "kind": "agenda"
  },
  {
   "id": "agenda.civic_hero",
   "name": "Civic Hero",
   "text": "You claimed 2+ City Problems.",
   "condition": {
    "stat": "problemsClaimed",
    "atLeast": 2
   },
   "vp": 5,
   "kind": "agenda"
  },
  {
   "id": "agenda.early_filer",
   "name": "Early Filer",
   "text": "You had cast 2 spells by the end of round 3.",
   "condition": {
    "stat": "spellsCastByRound3",
    "atLeast": 2
   },
   "vp": 4,
   "kind": "agenda"
  },
  {
   "id": "agenda.frugal_office",
   "name": "Frugal Office",
   "text": "You have 8+ mana left.",
   "condition": {
    "stat": "manaLeft",
    "atLeast": 8
   },
   "vp": 4,
   "kind": "agenda"
  },
  {
   "id": "agenda.strategic_reserve",
   "name": "Strategic Reserve",
   "text": "You have 8+ permits left.",
   "condition": {
    "stat": "permitsLeft",
    "atLeast": 8
   },
   "vp": 4,
   "kind": "agenda"
  },
  {
   "id": "agenda.memo_maniac",
   "name": "Memo Maniac",
   "text": "You played 5+ Action cards.",
   "condition": {
    "stat": "actionCardsPlayed",
    "atLeast": 5
   },
   "vp": 5,
   "kind": "agenda"
  },
  {
   "id": "agenda.market_regular",
   "name": "Market Regular",
   "text": "You bought 4+ spells at the Arcanium.",
   "condition": {
    "stat": "spellsBought",
    "atLeast": 4
   },
   "vp": 5,
   "kind": "agenda"
  },
  {
   "id": "agenda.big_ticket",
   "name": "Big Ticket",
   "text": "You have cast a spell with a mana price of 6+.",
   "condition": {
    "stat": "maxSpellPriceCast",
    "atLeast": 6
   },
   "vp": 4,
   "kind": "agenda"
  },
  {
   "id": "agenda.night_shift",
   "name": "Night Shift",
   "text": "You visited the Mana Conduit in 3+ different rounds.",
   "condition": {
    "stat": "conduitRounds",
    "atLeast": 3
   },
   "vp": 4,
   "kind": "agenda"
  },
  {
   "id": "agenda.grand_audience",
   "name": "Grand Audience",
   "text": "You visited the Grand Auditor's Office 3+ times.",
   "condition": {
    "stat": "auditorVisits",
    "atLeast": 3
   },
   "vp": 4,
   "kind": "agenda"
  },
  {
   "id": "agenda.paperless_office",
   "name": "Paperless Office",
   "text": "You have 2 or fewer permits and 2 or fewer mana left.",
   "condition": {
    "all": [
     {
      "stat": "permitsLeft",
      "atMost": 2
     },
     {
      "stat": "manaLeft",
      "atMost": 2
     }
    ]
   },
   "vp": 4,
   "kind": "agenda"
  },
  {
   "id": "agenda.ladder_climber",
   "name": "Ladder Climber",
   "text": "You reached 20 VP before round 7 began.",
   "condition": {
    "stat": "reached20BeforeRound7",
    "atLeast": 1
   },
   "vp": 5,
   "kind": "agenda"
  },
  {
   "id": "agenda.unfiled_sympathies",
   "name": "Unfiled Sympathies",
   "text": "You gained 6+ permits from \"of your choice\" effects.",
   "condition": {
    "stat": "choicePermitsGained",
    "atLeast": 6
   },
   "vp": 5,
   "kind": "agenda"
  },
  {
   "id": "agenda.collector",
   "name": "Collector",
   "text": "You have cast 6+ spells.",
   "condition": {
    "stat": "spellsCast",
    "atLeast": 6
   },
   "vp": 5,
   "kind": "agenda"
  },
  {
   "id": "agenda.heavy_hitter",
   "name": "Heavy Hitter",
   "text": "Your cast spells have a total printed VP of 15+.",
   "condition": {
    "stat": "totalPrintedVp",
    "atLeast": 15
   },
   "vp": 5,
   "kind": "agenda"
  },
  {
   "id": "agenda.master_specialist",
   "name": "Master Specialist",
   "text": "You have cast 4+ spells of one school.",
   "condition": {
    "stat": "maxSchoolCount",
    "atLeast": 4
   },
   "vp": 6,
   "kind": "agenda"
  },
  {
   "id": "agenda.treasury_favourite",
   "name": "Treasury Favourite",
   "text": "You claimed 3+ City Problems.",
   "condition": {
    "stat": "problemsClaimed",
    "atLeast": 3
   },
   "vp": 6,
   "kind": "agenda"
  },
  {
   "id": "agenda.legislator",
   "name": "Legislator",
   "text": "You enacted 2+ Decrees, and at least 1 of them is still in force.",
   "condition": {
    "all": [
     {
      "stat": "decreesEnacted",
      "atLeast": 2
     },
     {
      "stat": "decreesInForce",
      "atLeast": 1
     }
    ]
   },
   "vp": 5,
   "kind": "agenda"
  },
  {
   "id": "agenda.whistleblower",
   "name": "Whistleblower",
   "text": "You filed 2+ Appeals (Under Review or Revoke).",
   "condition": {
    "stat": "appealsFiled",
    "atLeast": 2
   },
   "vp": 4,
   "kind": "agenda"
  },
  {
   "id": "agenda.toll_baron",
   "name": "Toll Baron",
   "text": "You collected 4+ mana from rivals.",
   "condition": {
    "stat": "manaCollected",
    "atLeast": 4
   },
   "vp": 5,
   "kind": "agenda"
  }
 ],
 "decrees": [
  {
   "id": "decree.open_records",
   "name": "Open Records",
   "text": "The Archive draws 1 more Action card.",
   "flavor": "Freedom of Information, now with slightly less freedom and considerably more information.",
   "effects": [
    {
     "type": "archiveDraw",
     "delta": 1
    }
   ],
   "kind": "decree"
  },
  {
   "id": "decree.expedited_planning",
   "name": "Expedited Planning",
   "text": "The Planning Office plays 1 more Action card.",
   "flavor": "Meetings shortened to eleven minutes. Minutes shortened to one word.",
   "effects": [
    {
     "type": "planningPlays",
     "delta": 1
    }
   ],
   "kind": "decree"
  },
  {
   "id": "decree.open_plan_office",
   "name": "Open-Plan Office",
   "text": "Every location holds 1 more Assistant.",
   "flavor": "Walls are a relic of the old regime. So is privacy.",
   "effects": [
    {
     "type": "capacity",
     "delta": 1
    }
   ],
   "kind": "decree"
  },
  {
   "id": "decree.civic_bonus",
   "name": "Civic Bonus Scheme",
   "text": "Every City Problem is worth 1 more {VP}.",
   "flavor": "Solve the city's problems, receive a certificate. Frame not included.",
   "effects": [
    {
     "type": "problemVp",
     "delta": 1
    }
   ],
   "kind": "decree"
  },
  {
   "id": "decree.public_stipend",
   "name": "Public Stipend",
   "text": "At the start of each round, every player gains 1 more {MANA}.",
   "flavor": "A modest allowance, so no clerk need ever cast on an empty stomach.",
   "effects": [
    {
     "type": "upkeep",
     "mana": 1
    }
   ],
   "kind": "decree"
  },
  {
   "id": "decree.mana_rationing",
   "name": "Mana Rationing",
   "text": "The Mana Conduit gives 1 less {MANA}.",
   "flavor": "Please limit yourself to one surge per visit. Offenders will be grounded.",
   "effects": [
    {
     "type": "locationBonus",
     "location": "mana-conduit",
     "mana": -1
    }
   ],
   "kind": "decree"
  },
  {
   "id": "decree.conduit_toll",
   "name": "Conduit Toll",
   "text": "A rival visiting the Mana Conduit pays this Decree's author 1 {MANA}.",
   "flavor": "Exact change only. The turnstile bites.",
   "effects": [
    {
     "type": "toll",
     "location": "mana-conduit",
     "mana": 1
    }
   ],
   "kind": "decree"
  },
  {
   "id": "decree.arcanium_levy",
   "name": "Arcanium Levy",
   "text": "A rival visiting the Arcanium pays this Decree's author 1 {MANA}.",
   "flavor": "A small surcharge for the privilege of browsing. Browsing is a privilege.",
   "effects": [
    {
     "type": "toll",
     "location": "arcanium",
     "mana": 1
    }
   ],
   "kind": "decree"
  },
  {
   "id": "decree.paper_shortage",
   "name": "Paper Shortage",
   "text": "Every player's Action hand limit is 2 lower.",
   "flavor": "Please write smaller. And on both sides. And on the desk, if you must.",
   "effects": [
    {
     "type": "handLimit",
     "delta": -2
    }
   ],
   "kind": "decree"
  },
  {
   "id": "decree.streamlined_forms",
   "name": "Streamlined Forms",
   "text": "Every spell costs 1 fewer permit of its school's colour (minimum 1).",
   "flavor": "Form 9-C now fits on a single page, provided the page is very large.",
   "effects": [
    {
     "type": "schoolCost",
     "delta": -1,
     "min": 1
    }
   ],
   "kind": "decree"
  },
  {
   "id": "decree.price_controls",
   "name": "Price Controls",
   "text": "Arcanium spells cost 1 less {MANA}.",
   "flavor": "The shopkeepers are furious. The shopkeepers are always furious.",
   "effects": [
    {
     "type": "arcaniumPrice",
     "delta": -1
    }
   ],
   "kind": "decree"
  }
 ],
 "resolutions": [
  {
   "id": "resolution.currency_reform",
   "name": "Currency Reform",
   "spice": "bold",
   "requires": [],
   "text": "Pay 3 {MANA} in place of 1 permit.",
   "rules": "When you pay a spell's permit cost or a City Problem's permit fee, you may pay any of those permits with 3 {MANA} each, whatever the colour. Mana is never paid with permits. It does not count toward \"have N permits\" requirements.",
   "flavor": "The Treasury now accepts mana, sealing wax and, on alternate Tuesdays, sincere apologies.",
   "onEnact": [],
   "modifiers": [
    {
     "type": "substitutePayment",
     "payWith": "mana",
     "rate": 3
    }
   ],
   "kind": "resolution"
  },
  {
   "id": "resolution.storm_power",
   "name": "Storm Power",
   "spice": "mild",
   "requires": [],
   "text": "The Dept. of Evocation also gives 1 {MANA}.",
   "rules": "The Dept. of Evocation's effect also gives 1 {MANA}. It is part of the room's effect, so anything that resolves the room again (Magical Weather, Morning Rush) gives it again.",
   "flavor": "The lightning column now feeds the mains. The lights dim whenever someone files a complaint.",
   "onEnact": [],
   "modifiers": [
    {
     "type": "locationBonus",
     "location": "evocation",
     "mana": 1
    }
   ],
   "kind": "resolution"
  },
  {
   "id": "resolution.magical_weather",
   "name": "Magical Weather",
   "spice": "bold",
   "requires": [],
   "text": "On a Department visit, flip a coin. Heads: double.",
   "rules": "Each time a Department's effect resolves, the Ministry flips a coin. Heads: the effect resolves one more time (that extra time does not flip). Tails: nothing extra. \"When you visit\" abilities still happen once.",
   "flavor": "Forecast: scattered paperwork, with a fifty per cent chance of everything twice.",
   "onEnact": [],
   "modifiers": [
    {
     "type": "locationEffectRepeat",
     "keyword": "department",
     "chance": "coinFlip"
    }
   ],
   "kind": "resolution"
  },
  {
   "id": "resolution.open_shelves",
   "name": "Open Shelves",
   "spice": "mild",
   "requires": [
    "P-16"
   ],
   "text": "Refreshing the Arcanium is free.",
   "rules": "At the Arcanium, clearing and refilling the display costs nothing. You may still do it only once per visit, before you buy.",
   "flavor": "Browsing is no longer a privilege. It is merely strongly encouraged.",
   "onEnact": [],
   "modifiers": [
    {
     "type": "arcaniumRefreshCost",
     "value": 0
    }
   ],
   "kind": "resolution"
  },
  {
   "id": "resolution.ceremonial_stipend",
   "name": "Ceremonial Stipend",
   "spice": "mild",
   "requires": [
    "P-11"
   ],
   "text": "The Office of Precedence also gives 1 {MANA}.",
   "rules": "The Office of Precedence's effect also gives 1 {MANA}. It is part of the room's effect.",
   "flavor": "A small honorarium for whoever takes the Stamp. The Stamp takes it very seriously.",
   "onEnact": [],
   "modifiers": [
    {
     "type": "locationBonus",
     "location": "precedence",
     "mana": 1
    }
   ],
   "kind": "resolution"
  },
  {
   "id": "resolution.night_market",
   "name": "Night Market",
   "spice": "bold",
   "requires": [],
   "text": "The Mana Conduit also lets you buy a spell.",
   "rules": "After the Mana Conduit gives you its mana, you may buy 1 spell from the Arcanium display at its price (price changes apply). It counts as a purchase, but not as a visit to the Arcanium: no refresh, no Arcanium toll, no \"when you visit the Arcanium\" abilities.",
   "flavor": "After hours the portal traders set up by the fountain. Their receipts glow faintly.",
   "onEnact": [],
   "modifiers": [
    {
     "type": "locationAfter",
     "location": "mana-conduit",
     "effect": [
      {
       "op": "buySpell",
       "noRefresh": true
      }
     ]
    }
   ],
   "kind": "resolution"
  },
  {
   "id": "resolution.labour_accord",
   "name": "Labour Accord",
   "spice": "bold",
   "requires": [
    "P-12"
   ],
   "text": "Interns arrive next round.",
   "rules": "Every player's Intern arrives at the start of the next round, if that is earlier than planned. Enacted at the end of round 5 or later, it changes nothing.",
   "flavor": "The union has negotiated an earlier start. The Interns were not consulted.",
   "onEnact": [
    {
     "op": "setInternRound",
     "round": "next"
    }
   ],
   "modifiers": [],
   "kind": "resolution"
  },
  {
   "id": "resolution.morning_rush",
   "name": "Morning Rush",
   "spice": "bold",
   "requires": [],
   "text": "Each round's first placement resolves twice.",
   "rules": "The first Assistant placed each round, by any player, resolves its location's effect twice. Tolls are paid once and \"when you visit\" abilities happen once. At the Grand Auditor's Office you may claim twice (a different Problem each time).",
   "flavor": "The early clerk gets the form. Twice, if the queue is short enough.",
   "onEnact": [],
   "modifiers": [
    {
     "type": "firstPlacementRepeat",
     "times": 1
    }
   ],
   "kind": "resolution"
  },
  {
   "id": "resolution.memos_fly_free",
   "name": "Memos Fly Free",
   "spice": "bold",
   "requires": [],
   "text": "Play 1 Action card per round, anywhere.",
   "rules": "Once per round, as a free action on your turn, you may play 1 Action card from your hand, as if at the Planning Office. It counts as playing an Action card for everything. The Planning Office still works as before.",
   "flavor": "The jam is cleared. Memos now deliver themselves, folded into very officious aeroplanes.",
   "onEnact": [],
   "modifiers": [
    {
     "type": "freeActionCard",
     "perRound": 1
    }
   ],
   "kind": "resolution"
  },
  {
   "id": "resolution.fog_lifts",
   "name": "The Fog Lifts",
   "spice": "bold",
   "requires": [],
   "text": "All hands are public.",
   "rules": "From now on every player's spell hand and Action hand are face up for everyone, spectators included. Secret Agendas and the order of the decks stay hidden.",
   "flavor": "With the mist gone, everyone can see exactly what everyone else is holding. Awkward.",
   "onEnact": [
    {
     "op": "revealHands"
    }
   ],
   "modifiers": [],
   "kind": "resolution"
  },
  {
   "id": "resolution.free_roads",
   "name": "Free Roads",
   "spice": "mild",
   "requires": [],
   "text": "Toll Decrees are struck and can't return.",
   "rules": "Every Decree in force with a toll (Conduit Toll, Arcanium Levy) is struck. For the rest of the game, casting a toll Decree enacts nothing, and the Ministry never issues one. Levies that are not Decrees still apply.",
   "flavor": "Every bridge in the Old Quarter is free to cross again. The toll collectors have unionised.",
   "onEnact": [
    {
     "op": "strikeDecrees",
     "modifier": "toll"
    }
   ],
   "modifiers": [
    {
     "type": "banDecrees",
     "modifier": "toll"
    }
   ],
   "kind": "resolution"
  },
  {
   "id": "resolution.early_closing",
   "name": "Early Closing",
   "spice": "wild",
   "requires": [],
   "text": "The game ends after round 7.",
   "rules": "The Ministry closes at 4 PM: round 7 is the last round. Enacted at the end of round 7, the game goes straight to the Final Audit.",
   "flavor": "By popular demand, the Ministry now closes at four. Nobody asked whose demand.",
   "onEnact": [
    {
     "op": "setLastRound",
     "round": 7
    }
   ],
   "modifiers": [],
   "kind": "resolution"
  },
  {
   "id": "resolution.foreign_exchange",
   "name": "Foreign Exchange",
   "spice": "bold",
   "requires": [
    "P-18"
   ],
   "text": "Opens the Exchange Bureau.",
   "rules": "The Exchange Bureau opens in an Annex bay: return up to 2 of your permits, then gain that many permits of your choice. If both bays are full, the room that opened first closes for good.",
   "flavor": "Permits of every colour, exchanged at a rate the Bureau describes as \"fair, eventually\".",
   "onEnact": [
    {
     "op": "openAnnex",
     "location": "exchange-bureau"
    }
   ],
   "modifiers": [],
   "kind": "resolution"
  },
  {
   "id": "resolution.lost_and_found",
   "name": "Lost and Found",
   "spice": "bold",
   "requires": [
    "P-18"
   ],
   "text": "Opens Lost Property.",
   "rules": "Lost Property opens in an Annex bay: take 1 spell of your choice from the spell discard into your hand. If both bays are full, the room that opened first closes for good.",
   "flavor": "The Bureau of Lost Things has been found. It had a great deal to say about everyone's filing.",
   "onEnact": [
    {
     "op": "openAnnex",
     "location": "lost-property"
    }
   ],
   "modifiers": [],
   "kind": "resolution"
  },
  {
   "id": "resolution.confidential_waste",
   "name": "Confidential Waste",
   "spice": "bold",
   "requires": [
    "P-18"
   ],
   "text": "Opens the Shredding Room.",
   "rules": "The Shredding Room opens in an Annex bay: discard up to 2 cards from your hands (spells or Action cards), then gain 1 permit of your choice for each. If both bays are full, the room that opened first closes for good.",
   "flavor": "The haunted cabinets were exorcised, shredded and recycled. Mostly in that order.",
   "onEnact": [
    {
     "op": "openAnnex",
     "location": "shredding-room"
    }
   ],
   "modifiers": [],
   "kind": "resolution"
  },
  {
   "id": "resolution.stamps_rounded_up",
   "name": "Stamps Rounded Up",
   "spice": "bold",
   "requires": [
    "P-18"
   ],
   "text": "Opens the Stamp Pound.",
   "rules": "The Stamp Pound opens in an Annex bay: the next spell you cast this round costs 2 fewer permits of your choice (a colour may reach 0; it stacks with Legal Precedent and lapses at the end of the round). If both bays are full, the room that opened first closes for good.",
   "flavor": "Every runaway stamp now lives here, where it approves discounts and nothing else.",
   "onEnact": [
    {
     "op": "openAnnex",
     "location": "stamp-pound"
    }
   ],
   "modifiers": [],
   "kind": "resolution"
  },
  {
   "id": "resolution.complaints_upheld",
   "name": "Complaints Upheld",
   "spice": "bold",
   "requires": [
    "P-18"
   ],
   "text": "Opens the Complaints Desk.",
   "rules": "The Complaints Desk opens in an Annex bay: each rival with more {VP} than you pays you 1 {MANA}, if they have it. If both bays are full, the room that opened first closes for good.",
   "flavor": "The backlog is cleared. Complaints against the successful are now processed first.",
   "onEnact": [
    {
     "op": "openAnnex",
     "location": "complaints-desk"
    }
   ],
   "modifiers": [],
   "kind": "resolution"
  },
  {
   "id": "resolution.post_delivered",
   "name": "Post Delivered",
   "spice": "bold",
   "requires": [
    "P-18"
   ],
   "text": "Opens the Mailroom.",
   "rules": "The Mailroom opens in an Annex bay: draw 1 Action card, then you may play 1 Action card from your hand (the one you just drew included). If both bays are full, the room that opened first closes for good.",
   "flavor": "The inkwells have dried. The post goes out on time, give or take the occasional curse.",
   "onEnact": [
    {
     "op": "openAnnex",
     "location": "mailroom"
    }
   ],
   "modifiers": [],
   "kind": "resolution"
  }
 ],
 "resolutionSets": {
  "first-pass": [
   "resolution.currency_reform",
   "resolution.storm_power",
   "resolution.magical_weather",
   "resolution.open_shelves",
   "resolution.ceremonial_stipend",
   "resolution.night_market",
   "resolution.labour_accord",
   "resolution.morning_rush",
   "resolution.memos_fly_free",
   "resolution.fog_lifts",
   "resolution.free_roads",
   "resolution.early_closing",
   "resolution.foreign_exchange",
   "resolution.lost_and_found",
   "resolution.confidential_waste",
   "resolution.stamps_rounded_up",
   "resolution.complaints_upheld",
   "resolution.post_delivered"
  ]
 },
 "ranks": [
  {
   "title": "Form Initiate",
   "minVp": 0
  },
  {
   "title": "Subclause Apprentice",
   "minVp": 5
  },
  {
   "title": "Certified Spell Clerk",
   "minVp": 10
  },
  {
   "title": "Arcane Notarist",
   "minVp": 15
  },
  {
   "title": "Deputy Hexecutive",
   "minVp": 20
  },
  {
   "title": "Grand Inkwright",
   "minVp": 25
  },
  {
   "title": "Arch-Commissioner of Approvals",
   "minVp": 30
  }
 ],
 "defaults": {
  "rounds": 8,
  "startingAssistants": 2,
  "startingMana": [
   4,
   5,
   5,
   6,
   6
  ],
  "capacity": {
   "2": 1,
   "3": 1,
   "4": 2,
   "5": 2
  },
  "archiveDraw": 2,
  "planningPlays": 2,
  "actionHandLimit": 5,
  "arcaniumSize": 5,
  "upkeepMana": 1,
  "problemsRevealed": "playersPlus1",
  "problemTiers": true,
  "startingSpells": 2,
  "startingActions": 2,
  "noLegalLocationMana": 1,
  "draft": true,
  "draftIdentities": 2,
  "draftAgendas": 2,
  "cardValues": "v2",
  "decreeSlots": 4,
  "decreeVp": 2,
  "precedenceOffice": true,
  "internRound": 6,
  "assistantCap": 4,
  "decreeRounds": [
   3,
   5
  ],
  "arcaniumRefreshCost": 1,
  "resolutions": true,
  "resolutionSet": "first-pass",
  "annexRooms": true,
  "annexBays": 2,
  "maxWildRevealed": 2,
  "precedenceHolderBan": false
 },
 "presets": {
  "v1": {
   "startingMana": [
    4,
    5,
    6,
    7,
    8
   ],
   "capacity": {
    "2": 2,
    "3": 2,
    "4": 2,
    "5": 2
   },
   "archiveDraw": 1,
   "planningPlays": 1,
   "problemsRevealed": "all",
   "problemTiers": false,
   "draft": false,
   "cardValues": "v1",
   "decreeSlots": 2,
   "precedenceOffice": false,
   "internRound": null,
   "assistantCap": null,
   "decreeRounds": [],
   "arcaniumRefreshCost": null,
   "resolutions": false,
   "annexRooms": false
  }
 }
}
